import $ from 'jquery';

const recentPosts = $('.recent-posts-slider .container');
if (recentPosts.length) {
  recentPosts.slick({
    centerMode: true,
    slidesToShow: 3,
    variableWidth: false,
    adaptiveHeight: false,
    dots: true,
    arrows: false,
    infinite: false,
    initialSlide: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          arrows: false,
          centerMode: true,
          slidesToShow: 2,
          variableWidth: false,
          infinite: false,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          arrows: false,
          centerMode: true,
          slidesToShow: 3,
          variableWidth: false,
          infinite: false,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 960,
        settings: {
          arrows: false,
          centerMode: true,
          slidesToShow: 2,
          variableWidth: false,
          infinite: false,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 680,
        settings: {
          arrows: false,
          centerMode: false,
          slidesToShow: 1,
          variableWidth: false,
          infinite: false,
        },
      },
    ],
  });
}

const scrollToTop = $('.scroll-to-top');
if (scrollToTop.length) {
  $(document).on('scroll', function () {
    if ($(this).scrollTop() > 250) {
      scrollToTop.fadeIn();
    } else {
      scrollToTop.fadeOut();
    }
  });

  scrollToTop.on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, 1000);
  });
}
